(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lbl-explainer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function replay(panel) {
      if (!panel || reduceMotion.matches) return;
      panel.classList.remove('is-entering');
      void panel.offsetWidth;
      panel.classList.add('is-entering');
    }

    function init(root) {
      if (!root || root.dataset.lblWhyReady === 'true') return;
      root.dataset.lblWhyReady = 'true';

      var switcher = root.querySelector('[data-lbl-why-switch]');
      var tabs = switcher ? Array.prototype.slice.call(switcher.querySelectorAll('[role="tab"]')) : [];
      var panels = tabs.map(function (tab) {
        return document.getElementById(tab.getAttribute('aria-controls'));
      });
      var current = 0;

      function select(index, focus) {
        if (!tabs.length || index === current) {
          if (focus && tabs[index]) tabs[index].focus();
          return;
        }
        current = index;
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          if (panels[i]) panels[i].hidden = !on;
        });
        switcher.classList.toggle('is-second', index === 1);
        replay(panels[index]);
        if (focus) tabs[index].focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          select(i);
        });
        tab.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== null) {
            event.preventDefault();
            select(next, true);
          }
        });
      });

      // A sideways swipe over the pictures turns to the other side.
      var area = root.querySelector('[data-lbl-why-panels]');
      if (area && tabs.length > 1) {
        var startX = null;
        var startY = 0;
        area.addEventListener(
          'touchstart',
          function (event) {
            if (event.touches.length !== 1) return;
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
          },
          { passive: true }
        );
        area.addEventListener(
          'touchend',
          function (event) {
            if (startX === null) return;
            var touch = event.changedTouches[0];
            var dx = touch.clientX - startX;
            var dy = touch.clientY - startY;
            startX = null;
            if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) {
              select(dx < 0 ? Math.min(current + 1, tabs.length - 1) : Math.max(current - 1, 0));
            }
          },
          { passive: true }
        );
      }

      // In the theme editor, choosing a picture shows the side it belongs to.
      root.addEventListener('shopify:block:select', function (event) {
        var panel = event.target && event.target.closest ? event.target.closest('[role="tabpanel"]') : null;
        var index = panels.indexOf(panel);
        if (index > -1) select(index);
      });

      // The pictures rise in gently the first time the section comes into view.
      var designMode = window.Shopify && window.Shopify.designMode;
      if (!designMode && !reduceMotion.matches && 'IntersectionObserver' in window) {
        root.classList.add('is-armed');
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              observer.disconnect();
              root.classList.remove('is-armed');
              replay(panels[current] || root.querySelector('.lbl-why__panel'));
            });
          },
          { rootMargin: '0px 0px -18% 0px' }
        );
        observer.observe(area || root);
      }
    }

    function run() {
      document.querySelectorAll('[data-lbl-why]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector('[data-lbl-why]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbl-topics"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function init(root) {
      if (!root || root.dataset.lblTopicsReady === 'true') return;
      root.dataset.lblTopicsReady = 'true';
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      var panels = tabs.map(function (tab) {
        return document.getElementById(tab.getAttribute('aria-controls'));
      });
      var current = 0;

      function select(index, focus) {
        if (index === current) {
          if (focus) tabs[index].focus();
          return;
        }
        current = index;
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          if (panels[i]) panels[i].hidden = !on;
        });
        var panel = panels[index];
        if (panel && !reduceMotion.matches) {
          panel.classList.remove('is-entering');
          void panel.offsetWidth;
          panel.classList.add('is-entering');
        }
        if (focus) tabs[index].focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          select(i);
        });
        tab.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== null) {
            event.preventDefault();
            select(next, true);
          }
        });
      });

      // In the theme editor, choosing a part shows its chapters.
      root.addEventListener('shopify:block:select', function (event) {
        var index = tabs.indexOf(event.target);
        if (index > -1) select(index);
      });
    }

    function run() {
      document.querySelectorAll('[data-lbl-topics]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector('[data-lbl-topics]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
